import React, { useMemo, useState,  useContext } from 'react';
import Context from "../context/context";




const FilterTotals = props => {

  const {pagination, currentPage, totalItems, language} = useContext(Context);
  let viewed = currentPage * pagination.perpage;
  if (viewed > totalItems) {
    viewed = totalItems;
  }
  let filter_totals = language['no_results'];

  if (totalItems > 0) {
    filter_totals = "You have " + totalItems + " results to view."
    // filter_totals = language['filter_totals_end'].split('%')[0] + " " + viewed + " " + "results to view";
  }
  if (totalItems == 1){
    filter_totals = "You have " + totalItems + " result to view."

  }



  return (
    <>
      <div className="filter-totals">{filter_totals}</div>
    </>
  )
}

export default FilterTotals;
